// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Recommendation Display Styles */

.recommendation-display {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background-color: var(--color-grey-99);
  background-color: var(--color-grey-99);
  border-radius: 8px;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  min-width: 180px;
}

.recommendation-display__header {
  display: flex;
  align-items: center;
}

.recommendation-display__content {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/RecommendationDisplay.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Recommendation Display Styles */\n\n.recommendation-display {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  background-color: var(--color-grey-99);\n  background-color: var(--color-grey-99);\n  border-radius: 8px;\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  min-width: 180px;\n}\n\n.recommendation-display__header {\n  display: flex;\n  align-items: center;\n}\n\n.recommendation-display__content {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
